import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spinner } from './ui';

export default function AdminRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <Spinner size="lg" />
      </div>
    );
  }

  // Check if user has admin access
  const canAccessAdmin = user?.can_access_admin || user?.is_superuser;

  if (!canAccessAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
